<template>
  <div>
    <div class="d-flex justify-content-between button-group">
      <div>
      </div>
    </div>
    <div class="d-flex justify-content-between toggle-container" @click="showCollapse = !showCollapse"
         :aria-expanded="showCollapse ? 'true' : 'false'"
         aria-controls="collapse">
      <div class="icons-wrapper">
        <icon name="angle-down" class="angle" v-if="showCollapse"></icon>
        <icon name="angle-right" class="angle" v-else></icon>
      </div>
    </div>
    <b-collapse id="collapse" v-model="showCollapse">
      <b-row>
        <b-col align="right">
          <div class="d-flex justify-content-end button-group">
            <img src="@/assets/images/common-icons/icon_clear.png" @click="cleanFilters"
                 :title="$t('buttons.common.clear_filters')">
            <img src="@/assets/images/common-icons/icon_search.svg" @click="search"
                 :title="$t('buttons.common.search')">
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="1">
          <label>{{$t('labels.common.acceptance_date')}}</label>
        </b-col>
        <b-col cols="3">
          <range-date-picker v-model="searchData.acceptance_date" range lang="en"
                             range-separator="/" :first-day-of-week="1"></range-date-picker>
        </b-col>
        <b-col cols="1">
          <label>{{$t('labels.contracts.contract_number')}}</label>
        </b-col>
        <b-col cols="3">
          <multiselect v-model="searchData.contract" :max-height="200"
                       placeholder="Choose contract" label="contract_nr" track-by="id"
                       :options="contractsList"
                       :taggable="true"></multiselect>
        </b-col>
        <b-col cols=1>
          <label>{{$t('labels.purchase_orders.status')}}</label>
        </b-col>
        <b-col cols=3>
          <multiselect v-model="searchData.status" :max-height="200"
                       placeholder="Choose status"
                       :options="statuses"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols=1>
          <label>{{$t('labels.common.transport_nr')}}</label>
        </b-col>
        <b-col cols=3>
          <input class="form-control" v-model="searchData.transport_nr" @keyup.enter="search"
                 placeholder="">
        </b-col>
        <b-col cols=1>
          <label>{{$t('labels.common.supplier')}}</label>
        </b-col>
        <b-col cols=3>
          <multiselect v-model="searchData.supplier" :max-height="200"
                       placeholder="Choose supplier" label="name" track-by="id"
                       :options="suppliers"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col cols="1">
          <label>{{$t('labels.purchase_orders.delivery_date')}}</label>
        </b-col>
        <b-col cols="3">
          <range-date-picker v-model="searchData.delivery_term" range lang="en"
                             range-separator="/" :first-day-of-week="1"></range-date-picker>
        </b-col>
      </b-row>
    </b-collapse>
    <b-row>
      <b-col cols="5" class="d-flex justify-content-between padding-right-0">
        {{$t('labels.common.selected')}}: {{selectedPackages.length}}
        <save-columns-btn :grid="packagesListGridOptions" :grid-name="packagesGridName"></save-columns-btn>
      </b-col>
      <b-col class="d-flex justify-content-between padding-left-0" offset="1">
        {{$t('labels.common.selected')}}: {{selectedOrderItems.length}}
        <save-columns-btn :grid="orderItemsListGridOptions" :grid-name="orderItemsGridName"></save-columns-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="5" class="padding-right-0">
        <ag-grid-vue class="ag-theme-balham grid"
                     :style="gridHeight"
                     :rowData="packagesList"
                     :columnDefs="packagesListColumns"
                     :gridOptions="packagesListGridOptions"
                     @rowSelected="countSelectedPackages"
                     @rowDataChanged="countSelectedPackages"
                     :postProcessPopup="postProcessPopup">
        </ag-grid-vue>
      </b-col>
      <b-col cols="1" class="arrows-wrapper">
        <div v-if="currentRoutePermissions.add_purchaseorderitem" @click="bindOrderItem">
          <icon name="arrow-circle-right" class="bind-arrow"></icon>
        </div>
        <div v-if="currentRoutePermissions.delete_purchaseorderitem" @click="unbindOrderItem">
          <icon name="arrow-circle-left" class="bind-arrow"></icon>
        </div>
      </b-col>
      <b-col cols="6" class="padding-left-0">
        <ag-grid-vue class="ag-theme-balham grid"
                     :style="gridHeight"
                     :rowData="orderItems"
                     :columnDefs="orderItemsListColumns"
                     :gridOptions="orderItemsListGridOptions"
                     @rowSelected="countSelectedOrderItems"
                     @rowDataChanged="countSelectedOrderItems"
                     :postProcessPopup="postProcessPopup">
        </ag-grid-vue>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import { mapGetters, mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import RangeDatePicker from 'vue2-datepicker';
  import moment from 'moment';
  import SaveColumnsBtn from '@/components/common/SaveColumnsBtn';
  import {
    cleanFilters,
    saveFilters,
    setFilters,
    checkSavedFilterData,
    getArrayByProperty,
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { gridMixins } from '@/mixins';
  import { DATE_FORMAT } from '@/constants';

  export default {
    mixins: [gridMixins],
    components: {
      Multiselect,
      RangeDatePicker,
      SaveColumnsBtn,
      'ag-grid-vue':
      AgGridVue
    },
    data() {
      return {
        statuses: ['active', 'completed'],
        expandedPackages: [],
        selectedOrderItems: [],
        selectedPackages: [],
        showCollapse: true,
        searchData: {
          acceptance_date: '',
          contract: '',
          supplier: '',
          delivery_term: '',
          transport_nr: ''
        }
      }
    },
    methods: {
      countSelectedPackages() {
        this.selectedPackages = this.packagesListGridOptions.api.getSelectedRows();
      },
      countSelectedOrderItems() {
        this.selectedOrderItems = this.orderItemsListGridOptions.api.getSelectedRows();
      },
      cleanFilters() {
        cleanFilters(this.searchData);
      },
      async search() {
        const searchObject = {
          ...this.searchData,
          acceptance_date_between_after: this.searchData.acceptance_date && this.searchData.acceptance_date[0] ? moment(this.searchData.acceptance_date[0]).format(DATE_FORMAT) : '',
          acceptance_date_between_before: this.searchData.acceptance_date && this.searchData.acceptance_date[1] ? moment(this.searchData.acceptance_date[1]).format(DATE_FORMAT) : '',
          contract: this.searchData.contract ? this.searchData.contract.id : '',
          supplier: this.searchData.supplier ? this.searchData.supplier.id : '',
          delivery_term_between_after: this.searchData.delivery_term && this.searchData.delivery_term[0] ? moment(this.searchData.delivery_term[0]).format(DATE_FORMAT) : '',
          delivery_term_between_before: this.searchData.delivery_term && this.searchData.delivery_term[1] ? moment(this.searchData.delivery_term[1]).format(DATE_FORMAT) : ''
        };
        this.expandedPackages = [];
        this.packagesListGridOptions.api.forEachNode(node => node.expanded && node.key ? this.expandedPackages.push(node.data.acceptance_id) : '');
        await this.$store.dispatch('packagesBinding/loadGridData', searchObject);
        this.packagesListGridOptions.api.forEachNode(node => {
          if (node.key && this.expandedPackages.find(key => key === node.data.acceptance_id)) {
            node.expanded = true;
            this.packagesListGridOptions.api.onGroupExpandedOrCollapsed()
          }
        });
        saveFilters('packagesBinding', this.searchData);
      },
      openOrderItemModal(params) {
        if (params.data) {
          this.$http.get(`purchase/order_items/${params.data.id}/`).then(handlerResponse).then((response) => {
            this.$root.$emit('openCreateOrderItemModal', {...response, isNewItem: false});
          });
        } else {
          this.$root.$emit('openCreateOrderItemModal', {isNewItem: true});
        }
      },
      unbindOrderItem() {
        const unbindData = {
          pckgs_id: [],
          action: 'unbind'
        };
        unbindData.pckgs_id = getArrayByProperty(this.selectedOrderItems, 'package_id');
        if (unbindData.pckgs_id.length) {
          this.$http.put(`purchase/bind_package/`, unbindData).then(() => {
            this.search();
            this.$notify(setNotifyData('Success', 'Package has been successfully unbound', 'success'));
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          })
        } else {
          this.$notify(setNotifyData('', 'Select at least one package', 'error'));
        }
      },
      bindOrderItem() {
        const bindData = {
          pckgs_id: getArrayByProperty(this.selectedPackages, 'id'),
          poi_id: getArrayByProperty(this.selectedOrderItems, 'poi_id').toString(),
          action: 'bind'
        };
        if (bindData.pckgs_id && bindData.poi_id) {
          this.$http.put(`purchase/bind_package/`, bindData).then(() => {
            this.search();
            this.$notify(setNotifyData('Success', 'Package has been successfully bound', 'success'));
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          })
        } else {
          this.$notify(setNotifyData('', 'Select at least one package and one order item', 'error'));
        }
      }
    },
    computed: {
      ...mapState('generic', ['currentRoutePermissions']),
      ...mapState('partners', ['suppliers']),
      ...mapState('contracts', ['contractsList']),
      ...mapState('packagesBinding', ['packagesGridName', 'orderItemsGridName', 'packagesListColumns', 'packagesList', 'orderItemsListColumns', 'orderItems']),
      ...mapGetters('packagesBinding', {
        packagesListGridOptions: 'packagesListGridOptions',
        orderItemsListGridOptions: 'orderItemsListGridOptions'
      }),
      gridHeight() {
        if (window.innerHeight > 1024) {
          return this.showCollapse ? {height: 'calc(100vh - 330px)'} : {height: 'calc(100vh - 165px)'};
        } else {
          return this.showCollapse ? {height: '400px'} : {height: 'calc(100vh - 165px)'};
        }
      }
    },
    beforeMount() {
      this.$store.dispatch('partners/getSuppliers');
      this.$store.dispatch('contracts/loadContractsList');
      if (checkSavedFilterData('packagesBinding')) {
        this.searchData = setFilters('packagesBinding');
      }
    }
  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/pages/modules/purchases/binding/PackagesBinding.vue